import React, {Component} from "react"
import PropTypes from "prop-types"
import {set, get} from "lodash"
import styled from "styled-components"

import id from "@irati/utils/id"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Form from "@irati/ui/src/Form"
import Loading from "@irati/ui/src/Loading"
import Markdown from "@irati/ui/src/Markdown"
import {injectRouteWithQuery} from "@irati/utils/helpers/routing"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import auth from "@irati/auth"

import {ActionsWrapper, Footer, Interest} from "../../../components/Wizard"
import {PageWithStickyFooter} from "../../../components/Layout"
import {Card} from "../../../ui/Layout"
import sitemap from "../../../routes/sitemap"
import wizardHelper from "../../../helpers/wizard"
import {getInterests} from "../../../graph/interest"
import {PROPERTY as AOI_PROPERTY} from "../../../components/Wizard/Fields/Interest"
import {STEPS} from "../../../utils/constants/wizard"
import {NarrowStepIndicator} from "../../../ui/StepIndicator"
import {Breadcrumbs} from "../../../components/Navigation"

const ActionsWrapperGrow = styled(ActionsWrapper)`
  flex: 1;
`
class Step1 extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
  }
  static defaultProps = {}

  constructor(props) {
    super(props)

    this.idNamespace = id("Step1", this.props, {force: true})

    this.state = {
      form: {},
      options: [],
      load: this.getAreaOfInterestOptions(),
      submit: null
    }
  }

  getAreaOfInterestOptions = () => {
    return getInterests().then((interests) => {
      const options = wizardHelper.getSortedInterestList(interests.results)
      this.setState({
        options,
        form: {
          [AOI_PROPERTY]: options[0]
        }
      })
    })
  }

  handleChange = (form, property, value) => {
    set(form, property, value)
    this.setState({form})
  }

  renderFooter = () => {
    const {form} = this.state
    const interestId = form.interest ? form.interest.id : null
    const isComingSoon = get(form, `${AOI_PROPERTY}.contentId`) === "insights.areaOfInterest.custom"
    const buttonUrl = injectRouteWithQuery(sitemap.wizardStep2.url, {queryParams: {interestId}})

    const customEnabled = doIHavePermission(["insights.customSurvey"], auth.apps())

    return (
      <Footer fakeFirstElement>
        <NarrowStepIndicator activeStep={1} steps={STEPS} />
        <ActionsWrapperGrow>
          <ButtonRouterLink disabled={!customEnabled && isComingSoon} primary to={buttonUrl} id={id("submit-btn", this.idNamespace)}>
            <FormattedMessage
              id={!customEnabled && isComingSoon ? "insights.areaOfInterest.custom.tag" : "insights.wizard.step1.cta.next"} />
          </ButtonRouterLink>
        </ActionsWrapperGrow>
      </Footer>
    )
  }

  render() {
    const {match, intl} = this.props
    const {form, load, options} = this.state
    const crumbs = [sitemap.homepage, sitemap.wizardStep3]

    return (
      <Form>
        <PageWithStickyFooter id={this.idNamespace} footerChildren={this.renderFooter()} match={match}>
          <Breadcrumbs crumbs={crumbs} match={match} />
          <Loading load={load}>
            <Interest id={this.idNamespace} form={form} onChange={this.handleChange} options={options} />
            <Card>
              {form[AOI_PROPERTY] && <Markdown source={intl.formatMessage({id: `${form[AOI_PROPERTY].contentId}.description`})} />}
            </Card>
          </Loading>
        </PageWithStickyFooter>
      </Form>
    )
  }
}

export default injectIntl(Step1)
